import axios from './_nestAxios'

export const actualizarxId = async (id, data) => axios.put(`/ordenes-compra/${id}`, data)

export const getHistorialCambios = async idOrden => axios.get(`/ordenes-compra/${idOrden}/historial-cambios`)

export const obtenerxIdAsEdicion = async id => axios.get(`/ordenes-compra/${id}`)

export const getOrden_ParaCompra = async idDocumento =>
  axios.get(`/ordenes-compra/${idDocumento}`, {
    params: {
      tipoConsulta: 'info-compras'
    }
  })

export const getOrdenCompraOrden = async idDocumento =>
  axios.get(`/ordenes-compra/${idDocumento}`, {
    params: {
      tipoConsulta: 'compras-orden'
    }
  })

export const getOrden_SoloLectura = async idDocumento =>
  axios.get(`/ordenes-compra/${idDocumento}`, {
    params: {
      tipoConsulta: 'solo-lectura'
    }
  })

export const getOrdenes_ParaCompra = async params =>
  axios.get('/ordenes-compra', {
    params: {
      tipoConsulta: 'lista-compras',
      ...params
    }
  })

export const nueva = data => axios.post('/ordenes-compra', data)

export const cambiarEstado = (idOrden, data) => axios.post(`/ordenes-compra/${idOrden}/cambio-estado`, data)

export const descargarxId = async id => axios.get(`/ordenes-compra/descargar/${id}/A4`, { responseType: 'blob' })

export const enviarCorreo = async idDocumento => axios.post(`/ordenes-compra/${idDocumento}/enviar-correo`)
export const aprobarOrdenxId = id => axios.post(`/ordenes-compra/${id}/aprobar`)

export const descargarReporteOrdenes = params =>
  axios.get('/ordenes-compra/descargar-reporte', { responseType: 'blob', params })

export const obtenerPendientesAprobacion = params =>
  axios.get('/ordenes-compra/pendientes-aprobacion', { params })

export const aprobarDesdeVista = (id, data) =>
  axios.post(`/ordenes-compra/aprobar-desde-vista/${id}`, data)
